<template>
  <v-container>
  <div @click="menu = false" v-if="menu" class="invisible"></div>
    <v-card class="dt-border pad-10" flat>
      <v-container class="pt-10">
        <v-row class="pa-5 mb-5">
          <div>
            <h2>Wallet Transactions</h2>
          </div>
          <v-spacer></v-spacer>
          <v-form class="d-flex" @submit.prevent="name ? reload() : ''">
            <v-text-field
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              :clearable="true"
              rename
              v-model="name"
              placeholder="First name, last name or reference"
            />
            <v-btn class="ml-5" @click="name ? reload() : '' " color="primary" depressed>Search</v-btn>
          </v-form>
          <v-spacer></v-spacer>
          <div class="menu-container">
            <v-menu
              v-model="menu"
              style="box-shadow: none"
              :close-on-content-click="false"
              :close-on-click="false"
              :nudge-width="100"
              max-width="300"
              class="menu dt-border"
              offset-y
              left
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  outlined
                  rounded
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon> mdi-filter-variant </v-icon>
                  filter
                </v-btn>
              </template>
              <v-card class="pa-5" flat>
                <label for="">Status</label>
                <v-select
                  :items="statusList"
                  v-model="status"
                  item-text="text"
                  item-value="key"
                  dense
                  outlined
                  return-object
                ></v-select>
                <label for="">Type</label>
                <v-select
                  :items="typeList"
                  v-model="type"
                  item-text="text"
                  item-value="key"
                  dense
                  outlined
                  return-object
                ></v-select>
                <label for="">Slug</label>
                <v-select
                  :items="slugList"
                  v-model="slug"
                  item-text="text"
                  item-value="key"
                  dense
                  outlined
                  return-object
                ></v-select>
                <label for="">Date</label>
                <br />
               <DateRangePicker v-model="dateRange" />
                <v-card-actions>
                  <v-btn rounded depressed @click="reset">Reset</v-btn>
                  <v-btn color="primary" @click="reload()" rounded depressed
                    >Save</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-menu>
          </div>
        </v-row>
        <v-row class="pl-5">
          <div>
            <span
              v-if="details.total != 0 && this.loading == false"
              class="dt-orange white--text pa-2 rounded"
              >{{ details.total }} transactions</span
            >
          </div>
          <v-spacer></v-spacer>
          <dtunes-pagination
            @reload="reload"
            @nextPage="pageChangeHandle('next')"
            @previousPage="pageChangeHandle('previous')"
            :rows="rows"
            :limit="limit"
            :page="page"
            :totalPage="totalPage"
          />
        </v-row>
        <br /><br />
        <dtunes-loader :loading="loading"></dtunes-loader>
        <transactions-table :details="details"></transactions-table>
        <dtunes-empty v-if="details.total == 0 && this.loading == false">
          <template v-slot:title> No transaction has been carried out</template>
          <template v-slot:sub-title>
            <!-- Click on the create New Store button to create a Store -->
          </template>
        </dtunes-empty>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
// ============= IMPORT COMPONENTS ===========
import DtunesLoader from "@/components/dtunes-loader.vue";
import DtunesEmpty from "@/components/dtunes-empty.vue";
import TransactionsTable from "../components/transactions-table.vue";
import DtunesPagination from "@/components/dtunes-pagination.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";

// ========== IMPORT SERVICES =========
import { WalletService } from "@/services";
import { TransactionStatusEnum, TransactionSlugEnum } from "@/enums";

export default {
  components: {
    DateRangePicker,
    DtunesLoader,
    DtunesEmpty,
    TransactionsTable,
    DtunesPagination,
  },
  data: () => ({
    details: {},
    loading: false,
    statusList: [
      {
        text: "All",
        key: null,
      },
      {
        text: "Successful",
        key: TransactionStatusEnum.Successful,
      },
      {
        text: "Pending",
        key: TransactionStatusEnum.Pending,
      },
      {
        text: "Failed",
        key: TransactionStatusEnum.Failed,
      },
    ],
    typeList: [
      {
        text: "All",
        key: null,
      },
      {
        text: "Debit",
        key: "debit",
      },
      {
        text: "Credit",
        key: "credit",
      },
    ],
    slugList: [
      {
        text: "All",
        key: null,
      },
      {
        text: "Traded Giftcard",
        key: TransactionSlugEnum.TradedGiftcard,
      },
      {
        text: "Bank Transfer",
        key: TransactionSlugEnum.BankTransfer,
      },
      {
        text: "Withdrawal",
        key: TransactionSlugEnum.Withdrawal,
      },
      {
        text: "Referral Commission",
        key: TransactionSlugEnum.ReferralCommission,
      },
      {
        text: "Bill Payments",
        key: TransactionSlugEnum.BillPayment,
      },
      {
        text: "Withdrawal Refund",
        key: TransactionSlugEnum.WithdrawalRefund,
      },
      {
        text: "Credit Refund",
        key: TransactionSlugEnum.CreditRefund,
      },
    ],
    status: {
      text: "All",
      key: null,
    },
    slug: {
      text: "All",
      key: null,
    },
    type: {
      text: "All",
      key: null,
    },
    name: "",
    menu: false,
    rows: [10, 20, 50, 100],
    totalPage: 0,
    limit: 10,
    page: 1,
    dateRange: {
      startDate: null,
      endDate: null,
    },
    
  }),
  async mounted() {
    let date = new Date();
    let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.dateRange = {
      startDate: firstDay,
      endDate: lastDay,
    };
    await this.getTransactions();
  },
  methods: {
    async getTransactions() {
      try {
        let filter = {
          // name: this.name,
          type: this.type.key,
          slug: this.slug.key,
          status: this.status.key,
          startDate: this.dateRange.startDate,
          endDate: this.dateRange.endDate,
        };
        this.loading = true;
        const data = await WalletService.listTransactions({
          page: this.page,
          limit: this.limit,
          filters: this.cleanUpFilter(filter),
          search: this.name,
        });
        this.loading = false;
        this.details = data;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
      this.totalPage = Math.ceil(this.details.total / this.limit);
      this.menu = false;
    },

    async reload(value) {
      this.page = 1;
      if (value) {
        this.limit = value;
      }
      await this.getTransactions();
    },

    cleanUpFilter(obj) {
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === "") {
          delete obj[key];
        }
      });
      let check = Object.keys(obj).length === 0;
      return check ? null : obj;
    },

    async pageChangeHandle(value) {
      switch (value) {
        case "next":
          this.page += 1;
          break;
        case "previous":
          this.page -= 1;
          break;
        default:
          this.page = value;
      }
      this.getTransactions();
    },

    reset() {
      this.status = this.statusList[0];
      this.type = this.typeList[0];
      this.slug = this.slugList[0];
      let date = new Date();
      let firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      let lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.getTransactions();
    },
  },
  watch: {
    name (value) {
      if (!value) {
        this.reload();
      }
    },
  }
};
</script>

<style scoped>
.v-menu__content {
  /* box-shadow: none; */
  /* background-color: red !important; */
  border: 1px solid #ebebeb;
}
.invisible {
  opacity: 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}
.menu-container {
  position: relative;
  z-index: 999;
}
</style>